import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import IdleGuard from "@/components/IdleGuard";
import KioskGuard from "@/components/KioskGuard";
import { officerHasConsole } from "@/lib/access";
import { MfaEnrollGate } from "@/components/MfaEnrollGate";

const NO_IDLE_PREFIXES = ["/dismissal"];

export default function ProtectedRoute({ children, requireAdmin = false, requirePlatformOwner = false }) {
  const { user, loading } = useAuth();
  const { pathname } = useLocation();
  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-slate-50">
        <div className="text-slate-500 font-display text-lg" data-testid="auth-loading">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.mfa_enroll_required) return <MfaEnrollGate />;
  if (requirePlatformOwner && user.role !== "platform_owner") {
    return <Navigate to={user.role === "admin" ? "/admin" : "/kiosk"} replace />;
  }
  // For everything else, platform_owner shouldn't be browsing tenant routes
  if (!requirePlatformOwner && user.role === "platform_owner") {
    return <Navigate to="/platform" replace />;
  }
  if (requireAdmin && user.role !== "admin" && user.role !== "corporate_admin" && !officerHasConsole(user)) {
    return <Navigate to={user.role === "officer" ? "/kiosk" : user.role === "teacher" ? "/teacher" : user.role === "driver" ? "/driver" : "/portal"} replace />;
  }
  const content = (pathname === "/kiosk" || pathname.startsWith("/kiosk/")) ? <KioskGuard>{children}</KioskGuard> : children;
  if (NO_IDLE_PREFIXES.some((p) => pathname.startsWith(p))) return content;
  return <IdleGuard>{content}</IdleGuard>;
}
